import { createApp } from 'vue'
import App from './App.vue'

//toaster
import Toast, { PluginOptions, POSITION  } from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

//import { QrReader } from 'vue3-qr-reader';//funguje ale je to kopia z povodneho, cez setup()
import { createI18n } from 'vue-i18n'
import { createRouter, createWebHistory } from 'vue-router'


//import "viewerjs/dist/viewer.css";
//import Viewer from "v-viewer";

import {createPinia} from 'pinia';
const pinia = createPinia();


import vue3PhotoPreview from 'vue3-photo-preview';
import 'vue3-photo-preview/dist/index.css';

//core
import myLoginPage from './components/Common/LoginPage.vue'
import UserChangePassForm from './components/Core/UserChangePassword/ChangePass.vue'
import UsersList from './pages/Core/Users/Users.vue'
import GroupsList from './pages/Core/Groups/Groups.vue'
import LevelsList from './pages/Core/Levels/Levels.vue'
import ModsList from './pages/Core/Mods/Mods.vue'
import MenuItemsList from './pages/Core/MenuItems/MenuItems.vue'
import ParametersList from './pages/Core/Parameters/Parameters.vue'
import LangMutationList from './pages/Core/Mutations/Mutations.vue'
import ArticlesList from './components/Core/Articles/Articles.vue'
import ArticleEdit from './components/Core/Articles/ArticleEdit.vue'
import ArticleNew from './components/Core/Articles/ArticleEdit.vue'
import ArticleCategoriesList from './components/Core/ArticleCategories/ArticleCategories.vue'
import GalleryCategoriesList from './components/Core/GalleryCategories/GalleryCategories.vue'
import LibraryCategoriesList from './components/Core/LibraryCategories/LibraryCategories.vue'
import GalleriesList from './components/Core/Galleries/Galleries.vue'
import LibrariesList from './components/Core/Libraries/Libraries.vue'
import DocumentsList from './components/Core/Documents/Documents.vue'
import PhotosList from './components/Core/Photos/Photos.vue'
import TagsList from './components/Core/Tags/Tags.vue'
import SysLogsList from './components/Core/SysLogs/BasicList.vue'
import AuditLogs from './pages/Core/AuditLogs/BasicList.vue'
import custDashboard from './components/Custom/Dashboard.vue'

//working
import workingProjects from './components/CustomWorking/WorkingProjects/Projects.vue'
import workingTasks from './components/CustomWorking/WorkingTasks/Tasks.vue'

//weather
import weatherBasic from './components/CustomWeather/WeatherBasic/Weathers.vue'

//mailing
import mailingCampaigns from './components/CustomMailing/MailingCampaigns/Campaigns.vue'
import mailingContacts from './components/CustomMailing/MailingContacts/Contacts.vue'
import mailingContactCategories from './components/CustomMailing/MailingContactCategories/Categories.vue'
import mailingListEmail from './components/CustomMailing/MailingListEmail/BasicList.vue'
import mailingListSMS from './components/CustomMailing/MailingListSMS/BasicList.vue'


import pathNotFound from './components/Common/PageWasNotFound.vue'

//router
const webFolder = ''; //admins
const router = createRouter({
  //history: createWebHistory('/'),
  history: createWebHistory('/' + webFolder),
 // mode: 'history',
  routes: [
	{ path: '/', component: custDashboard },
	
	{ path: '/users', component: UsersList },
	{ path: '/groups', component: GroupsList },
	{ path: '/levels', component: LevelsList },
	{ path: '/mods', component: ModsList },
	{ path: '/menu-items', component: MenuItemsList },
	{ path: '/parameters', component: ParametersList },
	{ path: '/lang-mutations', component: LangMutationList },
	{ path: '/articles', component: ArticlesList },
	{ path: '/article/:id/edit', component: ArticleEdit },
	{ path: '/article/new', component: ArticleNew },
	{ path: '/article-categories', component: ArticleCategoriesList },
	{ path: '/gallery-categories', component: GalleryCategoriesList },
	{ path: '/library-categories', component: LibraryCategoriesList },
	{ path: '/galleries', component: GalleriesList },
	{ path: '/libraries', component: LibrariesList },
	{ path: '/documents', component: DocumentsList },
	{ path: '/photos', component: PhotosList },
	{ path: '/tags', component: TagsList },
	{ path: '/user-change-password', component: UserChangePassForm },
	{ path: '/sys-logs', component: SysLogsList },
	{ path: '/audit-logs', component: AuditLogs },
	{ path: '/login', component: myLoginPage },

	//mailing
	{ path: '/mailing-campaigns', component: mailingCampaigns },
	{ path: '/mailing-contacts', component: mailingContacts },
	{ path: '/mailing-contact-categories', component: mailingContactCategories },
	{ path: '/mailing-list-email', component: mailingListEmail },
	{ path: '/mailing-list-sms', component: mailingListSMS },

	//working
	{ path: '/working-projects', component: workingProjects },
	{ path: '/working-tasks', component: workingTasks },
	

	//weather
	{ path: '/weather-basic', component: weatherBasic },


	{ path: '/:pathMatch(.*)*', component: pathNotFound }
  ],
})



//import jazykov
import { languages } from './importLangs.js'
import { defaultLocale } from './importLangs.js'
const messages = Object.assign(languages)
const i18n = createI18n({
  locale: defaultLocale,
  fallbackLocale: 'sk',
  messages,
})




//createApp(App).use(router).use(i18n).use(QrReader).mount('#app')


const options: PluginOptions = {
    position: POSITION.BOTTOM_LEFT
	,timeout: 2500
	,toastClassName: "my-custom-toast-class"
};

const app = createApp(App)
app.config.globalProperties.adminfolder = webFolder;
//app.component("Datepicker", Datepicker);
app.use(router).use(i18n)//.use(QrReader)
// add more functionality to myV3App

app.use(Toast, options);

app.use(vue3PhotoPreview);

app.use(pinia);

//app.use(Viewer);

//app.use(SnackbarService)
//app.component("vue3-snackbar", Vue3Snackbar);

// now we're ready to mount
app.mount('#app')

//.use(QrReader)

